import React from 'react';
import { RootState, useDispatch, useSelector } from 'src/store';
import { setError } from '../../reducers/RenderRequestSlice';

export const ErrorMessage = () => {
  const dispatch = useDispatch();
  const { error } = useSelector((state: RootState) => state.renderRequest);
  if (!error) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)',
      zIndex: 300, display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div style={{
        background: 'var(--paper)', border: '1.5px solid var(--border)',
        borderRadius: 'var(--r-lg)', padding: '24px 28px',
        maxWidth: '400px', width: '90%',
      }}>
        <div style={{
          fontFamily: 'var(--font-mono)', fontSize: '.7rem', letterSpacing: '.1em',
          textTransform: 'uppercase', color: 'var(--accent)', marginBottom: '8px',
        }}>Error</div>
        <p style={{ fontSize: '.85rem', color: 'var(--ink)', lineHeight: 1.5, marginBottom: '16px' }}>{error}</p>
        <button className="btn" type="button" onClick={() => dispatch(setError(null))}>Dismiss</button>
      </div>
    </div>
  );
};
